module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2eafbafeeadf6ee799e6d04b4f21649b.png";